import * as yup from "yup";

export const validationSchema = yup.object().shape({
    title: yup.string(),
    body: yup.string().trim().required("Body field is required"),
});
